import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import Profile from '../../../endpoints/Person/Person';
import ContentGrid from '../../../grids/ContentGrid';
import Sidebar from '../../../components/Sidebar/Sidebar';
import fetcher from '../../../utils/fetcher';
import gql from '../../../endpoints/Person/person.gql';
import { parseEmbeddedAssets } from '../../../utils/utils';

import {
  fetchMemberDriveStatus,
  addMemberDriveElements,
} from '../../../utils/membershipUtils';

const ProfilePage = ({ data, errorCode }) => {
  if (errorCode) return <ErrorPage statusCode={errorCode} />;

  useEffect(() => {
    fetchMemberDriveStatus().then((data) => {
      addMemberDriveElements(data);
    });
  }, []);

  return (
    <ContentGrid sidebar={<Sidebar pageTopic={'Profiles'} />}>
      <Profile data={data} pageNum={1} />
    </ContentGrid>
  );
};

ProfilePage.getInitialProps = async ({ query: { slug, token }, res }) => {
  let data,
    errorCode = false;

  await fetcher(gql, {
    contentAreaSlug: process.env.CONTENT_AREA_SLUG,
    slug: slug.join('/'),
    previewToken: token,
  })
    .then((result) => {
      data = result;
      if (data?.profile?.parseEmbeddedAssets) {
        parseEmbeddedAssets(data.profile.parseEmbeddedAssets);
      }

      res.setHeader('Cache-Control', 'no-store, must-revalidate');
      if (!data.profile) {
        if (res) res.statusCode = 404;
        errorCode = 404;
      }
    })
    .catch(() => {
      if (res) res.statusCode = 500;
      errorCode = 500;
    });

  return {
    data,
    errorCode,
  };
};

ProfilePage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  data: PropTypes.object,
};

export default ProfilePage;
